import React from "react";
import { Card, Col, Row, Spinner,  ModalHeader, ModalBody, Modal, ModalFooter, Button } from "reactstrap";
import { IoMdInformationCircle } from "react-icons/io";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import formatters from "../../../config/formatters";
import { isMobile, isMobileOnly } from "react-device-detect";
import '@mantine/carousel/styles.css';
import { Carousel } from '@mantine/carousel';
import { useState } from 'react';
import { Theme } from "../../../config/constants";

const HighlightsCard = () => {
    const highlightsData = useSelector(({dashboard}) => dashboard.highlights);
    const isLoading = useSelector(({dashboard}) => dashboard.highlightsIsLoading);
    const usaIncluded = useSelector(({ dashboard }) => dashboard.appliedUsaIncluded);
    const { usCurrencyFormatter, numberFormatter } = formatters();
    const [carouselIndex, setCarouselIndex] = useState(0);
    const highlightsOptions = [
        {value: 'BEPL Business', label: 'Show: BEPL Business'},
    ];

    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => {
      setModalOpen(!modalOpen);
    }

    if (isMobileOnly) {
        return (  
            <Col>
                <Carousel withIndicators height={150} withControls={true} slideGap={4} controlsOffset="md" includeGapInSize={true} className='control' style={{zIndex: '0'}}>
                    {usaIncluded  && (
                        <Carousel.Slide >
                            <Card style={{  backgroundColor: '#CF3F7C', height: '110px', marginLeft: '0px', marginRight: '0px'}}>
                                <div>
                                    <Col style={{ marginLeft: '45px' }}>
                                        <Col>
                                            <div className="main-header text-white text-size-16 mt-3 d-flex align-items-center">Total Volume ($)</div>
                                        </Col>

                                        {isLoading &&
                                            <Row className="my-3 mx-auto w-fc">
                                                <Spinner color='beplBlue' animation="border" />
                                            </Row>
                                        }
                                        {!isLoading &&
                                            <Row className="my-1">
                                                <div className="main-header text-size-36 text-white" >{highlightsData.length <= 0 ? 'N/A' : usCurrencyFormatter.format(highlightsData.total_volume)}</div>
                                            </Row>
                                        }
                                    </Col>
                                </div>
                            </Card>
                        </Carousel.Slide>
                    )}
                    <Carousel.Slide>
                        <Card style={{ backgroundColor: '#CF3F7C' , height: '110px'}}>
                            <div className="carousel-item active ">
                                <Col style={{ marginLeft: '45px' }}>
                                    <Col>
                                        <div className="main-header text-white text-size-16 mt-3 d-flex align-items-center">Locations</div>
                                    </Col>

                                    {isLoading &&
                                        <Row className="my-3 mx-auto w-fc">
                                            <Spinner color='beplBlue' animation="border" />
                                        </Row>
                                    }
                                    {!isLoading &&
                                        <Row className="my-1">
                                            <div className="main-header text-size-36 text-white">{highlightsData.length <= 0 ? 'N/A' : numberFormatter.format(highlightsData.total_locations)}</div>
                                        </Row>
                                    }
                                </Col>
                            </div>
                        </Card>
                    </Carousel.Slide>
                    <Carousel.Slide>
                        <Card style={{ backgroundColor: '#CF3F7C' , height: '110px'}}>
                            <div className="carousel-item active ">
                                <Col style={{ marginLeft: '45px' }}>
                                    <Col>
                                        <div className="main-header text-white text-size-16 mt-3 d-flex align-items-center">Cases</div>
                                    </Col>

                                    {isLoading &&
                                        <Row className="my-3 mx-auto w-fc">
                                            <Spinner color='beplBlue' animation="border" />
                                        </Row>
                                    }
                                    {!isLoading &&
                                        <Row className="my-1">
                                            <div className="main-header text-size-36 text-white">{highlightsData.length <= 0 ? 'N/A' : numberFormatter.format(highlightsData.total_cases)}</div>
                                        </Row>
                                    }
                                </Col>
                            </div>
                        </Card>
                    </Carousel.Slide>
                </Carousel>

            </Col>
        );
    } else if (isMobile) {
        return (
                <Col>
                    <Col className='ps-0'>
                    <div className='main-header text-size-20' style={{ lineHeight: '23px', fontWeight: '700', letterSpacing: '.0025em' }}>
                        Today's Highlights -  {highlightsOptions[carouselIndex].value}
                        <IoMdInformationCircle className="text-beplMagenta text-size-18" onClick={toggleModal} />
                    </div>
                    <Modal isOpen={modalOpen} toggle={toggleModal} style={{ height: '90%' }}>
                        <ModalHeader >
                            Today's Highlights
                        </ModalHeader>
                        <ModalBody>
                            <div className="mx-3">
                                <Row><p><b>Total Volume:</b> This section will show you your total volume, direct volume or BEPL volume within the timeframe you select from the date filters.</p></Row>
                                <Row><p><b>Locations:</b>  Your total locations (ie, individual store locations) within the selected date range.</p></Row>
                                <Row><p><b>Cases:</b>  Your total cases across all categories in the selected date range</p></Row>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={toggleModal} block className='py-2' style={{ float: 'right', backgroundColor: '#CF3F7C', color: 'white' }} >Close</Button>
                        </ModalFooter>
                    </Modal>
                </Col>
                <Carousel withIndicators height={160} withControls={true} controlSize={20} slideGap={3} controlsOffset="xs" onSlideChange={(index) => setCarouselIndex(index)}>
                    {highlightsOptions?.map((option, index) => (
                        <Carousel.Slide key={index}>
                            <Row className="py-2" style={{ justifyContent: 'center' , marginRight: '0px', marginLeft: '0px'}}>
                                {usaIncluded  && (
                                    <Card style={{ backgroundColor: '#CF3F7C', height: '110px', maxWidth: '32%', marginRight: '3px' }}>
                                        <div>
                                            <Col style={{ marginLeft: '5px' }}>
                                                <Col>
                                                    <div className="main-header text-white text-size-16 mt-3 d-flex align-items-center">Total Volume ($)</div>
                                                </Col>
                                                {isLoading && (
                                                    <Row className="my-3 mx-auto w-fc">
                                                        <Spinner color='beplBlue' animation="border" />
                                                    </Row>
                                                )}
                                                {!isLoading && (
                                                    <Row className="my-1">
                                                        <div className="main-header text-size-32 text-white" >{highlightsData.length <= 0 ? 'N/A' : usCurrencyFormatter.format(highlightsData.total_volume)}</div>
                                                    </Row>
                                                )}
                                            </Col>
                                        </div>
                                    </Card>
                                )}
                                <Card style={{ backgroundColor: '#CF3F7C', height: '110px', maxWidth: '31%', marginRight: '3px' }}>
                                    <div className="carousel-item active ">
                                        <Col style={{ marginLeft: '5px' }}>
                                            <Col>
                                                <div className="main-header text-white text-size-16 mt-3 d-flex align-items-center">Locations</div>
                                            </Col>
                                            {isLoading && (
                                                <Row className="my-3 mx-auto w-fc">
                                                    <Spinner color='beplBlue' animation="border" />
                                                </Row>
                                            )}
                                            {!isLoading && (
                                                <Row className="my-1">
                                                    <div className="main-header text-size-32 text-white">{highlightsData.length <= 0 ? 'N/A' : numberFormatter.format(highlightsData.total_locations)}</div>
                                                </Row>
                                            )}
                                        </Col>
                                    </div>
                                </Card>
                                <Card style={{ backgroundColor: '#CF3F7C', height: '110px', maxWidth: '31%', marginRight: '3px' }}>
                                    <div className="carousel-item active ">
                                        <Col style={{ marginLeft: '5px' }}>
                                            <Col>
                                                <div className="main-header text-white text-size-16 mt-3 d-flex align-items-center">Cases</div>
                                            </Col>
                                            {isLoading && (
                                                <Row className="my-3 mx-auto w-fc">
                                                    <Spinner color='beplBlue' animation="border" />
                                                </Row>
                                            )}
                                            {!isLoading && (
                                                <Row className="my-1">
                                                    <div className="main-header text-size-32 text-white">{highlightsData.length <= 0 ? 'N/A' : numberFormatter.format(highlightsData.total_cases)}</div>
                                                </Row>
                                            )}
                                        </Col>
                                    </div>
                                </Card>

                            </Row>
                        </Carousel.Slide>
                    ))}
                </Carousel>
            </Col>
        )
    }

    return (
        <Col className="py-2">
            <Row style={{height: '4%'}}>
                {usaIncluded  && (
                    <Col className='col-4' style={{borderRight: '1px lightgray solid'}}>
                        <Row>
                            <Col>
                                <div className="main-header text-gray text-size-16">Total Volume ($)</div>
                            </Col>
                            <Col className="w-fc">
                                <Tooltip placement='top' title='This section will show you your total volume, direct volume or BEPL volume within the timeframe you select from the date filters' arrow>
                                    <div>
                                        <IoMdInformationCircle className="text-size-18" color={Theme().colors.accent} />
                                    </div>
                                </Tooltip>
                            </Col>
                        </Row>
                        {isLoading &&
                        <Row className="my-2 mx-auto w-fc">
                            <Spinner color='beplBlue' animation="border"/>
                        </Row>
                        }
                        {!isLoading && 
                        <Row className="my-2">
                            <div className="main-header text-size-36">{highlightsData.length <= 0 ? 'N/A' : usCurrencyFormatter.format(highlightsData.total_volume)}</div>
                        </Row>
                        }
                    </Col>
                )}
                <Col className={usaIncluded ? 'col-4' : 'col-6'} style={{borderRight: '1px lightgray solid'}}>
                    <Row>
                        <Col>
                            <div className="main-header text-gray text-size-16">Locations</div>
                        </Col>
                        <Col className="w-fc">
                            <Tooltip placement='top' title='Your total locations (ie, individual store locations) within the selected date range' arrow>
                                <div>
                                    <IoMdInformationCircle className="text-size-18" style={{color: Theme().colors.accent}} />
                                </div>
                            </Tooltip>
                        </Col>
                    </Row>
                    {isLoading && 
                    <Row className="my-2 mx-auto w-fc">
                        <Spinner color='beplBlue' animation="border"/>
                    </Row>
                    }
                    {!isLoading && 
                    <Row className="my-2">
                        <div className="main-header text-size-36">{highlightsData.length <= 0 ? 'N/A' : numberFormatter.format(highlightsData.total_locations)}</div>
                    </Row>
                    }
                </Col>
                <Col className={usaIncluded ? 'col-4' : 'col-6'}>
                    <Row>
                        <Col>
                            <div className="main-header text-gray text-size-16">Cases</div>
                        </Col>
                        <Col className="w-fc">
                            <Tooltip placement='top' title='Your total cases across all categories in the selected date range' arrow>
                                <div>
                                    <IoMdInformationCircle className="text-size-18" style={{color: Theme().colors.accent}}/>
                                </div>
                            </Tooltip>
                        </Col>
                    </Row>
                    {isLoading &&
                    <Row className="my-2 mx-auto w-fc">
                        <Spinner color='beplBlue' animation="border"/>
                    </Row>
                    }
                    {!isLoading &&
                    <Row className="my-2">
                        <div className="main-header text-size-36">{highlightsData.length <= 0 ? 'N/A' : numberFormatter.format(highlightsData.total_cases)}</div>
                    </Row>
                    }
                </Col>
            </Row>
        </Col>
    )   
}

export default HighlightsCard;